import axios from "axios";

import pagination from "../../pagination";
import filterable from "../../filterable";
import fetchable from "../../fetchable";
import { transVector } from "../selected";

export default {
  namespaced: true,
  modules: {
    pagination,
    filterable,
    fetchable,
  },
  state: {
    list: [],
    addedList: []
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
    updateVisualization(state, { visualizationId, visualizationAttributes }) {
      const vis = state.list.find((vis) => vis.id === visualizationId);
    
      if (vis) {
        Object.assign(vis, visualizationAttributes);
      }
    },
    addToEarth(state, visId) {
      const map = state.list.find(m => m.id === visId)
      if (map) {
        const cloneMap = JSON.parse(JSON.stringify(map))
        cloneMap.addedTime = Date.now()
        cloneMap.mapType = 'MapItem'
        cloneMap.module = 'starmapSelected'
        state.addedList.push(cloneMap)
      }
    },
    removeFromEarth(state, visId) {
      const idx = state.addedList.findIndex(m => m.id === visId)
      if (idx >= 0) {
        state.addedList.splice(idx,1)
      }
    }
  },
  actions: {
    async fetchList({ state, commit }) {
      if (state.fetchable.isFetching) return;
      commit('fetchable/setFetching', true)
      try {
        const response = await axios.get(`/static/starmap_layers.json`);
        let list = []
        if (state.filterable.filterKeyword) {
          const keyword = state.filterable.filterKeyword.toLowerCase();
          const filtered = response.data.filter((m) => {
            return m.name.toLowerCase().includes(keyword);
          });
          list = filtered;
        } else {
          list = response.data;
        }
        const page = state.pagination.page;
        const perPage = state.pagination.perPage;
        const start = (page - 1) * perPage;
        const end = page * perPage;
        const data = list.slice(start, end);
        const transList = data.map(transVector);
        const existIds = state.addedList.map(m => m.id);    
        commit("setList", transList.map(m => ({ 
          ...m, 
          added_to_map: existIds.includes(m.id), 
          visible: true
        })));
        commit("pagination/setTotalEntities", list.length);
      } catch (e) {
        commit("fetchable/setError", e);
      } finally {
        commit('fetchable/setFetching', false);
      }
    },

    async fetchPage(context, payload) {
      context.commit("pagination/setPage", payload.page);
      await context.dispatch("fetchList");
    },

    async fetchFilter(context, payload) {
      context.commit("filterable/setFilterType", payload.filterType);
      context.commit("filterable/setFilterKeyword", payload.filterKeyword);
      await context.dispatch("fetchList");
    },

    addToEarth({ state, commit }, visId) {
      commit("addToEarth", visId)
      const updateAttrs = {
            visualizationId: visId,
            visualizationAttributes: { added_to_map: true },
      };
      commit("updateVisualization", updateAttrs);
      const vis = state.addedList.find( m => m.id === visId)
      if (vis) {
        commit("maps/addToOrderList", vis, {root: true})
      }
    },

    removeFromEarth({ commit }, visId) {
      commit("removeFromEarth", visId)
      const updateAttrs = {
            visualizationId: visId,
            visualizationAttributes: { added_to_map: false },
      };
      commit("updateVisualization", updateAttrs);
      commit("maps/removeFromOrderList", visId, { root: true })
    }
  }
}